import type { CmmdBoardTask } from "@cmmd-forge/contracts";
import { RefreshCwIcon } from "lucide-react";
import type { ReactNode } from "react";

import { Button } from "~/components/ui/button";
import { ProjectTaskToolbar } from "../tasks/ProjectTaskToolbar";
import type { ProjectTaskChrome } from "../tasks/useProjectTaskChrome";
import type { ProjectTab } from "./CmmdProjectTabs";

export interface ProjectTabTrailingProps {
  readonly activeTab: ProjectTab;
  readonly taskChrome: ProjectTaskChrome | null;
  readonly tasks?: ReadonlyArray<CmmdBoardTask>;
  readonly onRefreshAutomations: () => void;
  readonly projectId?: number;
  readonly onWorkflowSaved?: (() => void | Promise<void>) | undefined;
  readonly workflowAvailable?: boolean;
  readonly taskMutationsDisabled?: boolean;
}

/** Page-specific controls for the Linear tabs-row trailing cluster. */
export function renderProjectTabTrailing(props: ProjectTabTrailingProps): ReactNode {
  if (props.activeTab === "tasks" && props.taskChrome) {
    const taskChrome = props.taskChrome;
    return (
      <ProjectTaskToolbar
        viewController={taskChrome.viewController}
        composerOpen={taskChrome.composerOpen}
        onToggleComposer={taskChrome.toggleComposer}
        milestones={taskChrome.milestones.milestones}
        onManageMilestones={() => taskChrome.setMilestoneManagerOpen(true)}
        {...(props.tasks ? { tasks: props.tasks } : {})}
        variant="trailing"
        {...(props.projectId ? { projectId: props.projectId } : {})}
        {...(props.onWorkflowSaved ? { onWorkflowSaved: props.onWorkflowSaved } : {})}
        {...(props.workflowAvailable != null ? { workflowAvailable: props.workflowAvailable } : {})}
        {...(props.taskMutationsDisabled != null
          ? { taskMutationsDisabled: props.taskMutationsDisabled }
          : {})}
      />
    );
  }
  if (props.activeTab === "automations") {
    return (
      <Button
        type="button"
        size="sm"
        variant="outline"
        onClick={props.onRefreshAutomations}
        className="h-8 gap-1.5 px-2.5 text-xs"
      >
        <RefreshCwIcon className="size-3.5" aria-hidden />
        Refresh
      </Button>
    );
  }
  return null;
}
